import { Directive } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[appPageContent]',
})
export class PageContentDirective {
  constructor() {}
}
